export default "__VITE_ASSET__939035e1__"